import common from "./common.json";
import configs from "./configs.json";
import errors from "./errors.json";
import tree from "./tree.json";
import validation from "./validation.json";

export const en = {
	common,
	configs,
	errors,
	tree,
	validation,
};
